// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lHueS","right":"styles_right__26k1c"};